// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"d7c170f0","290":"532ea6d0","400":"e187af6e","716":"30ca2b93"}[chunkId] + ".chunk.js";
};